import type { IconAsset } from '../Icon.types';

export const telephoneCall: IconAsset = {
  regular: {
    l: {
      code: (
        <g>
          <path d='M0,0H24V24H0Z' fill='none' />
          <path
            d='M19.2,14.79a10.9,10.9,0,0,1-3.362-.533.931.931,0,0,0-.962.229l-1.5,1.876a14.459,14.459,0,0,1-6.561-6.5L8.676,8.276A.972.972,0,0,0,8.9,7.3a10.621,10.621,0,0,1-.533-3.362A.951.951,0,0,0,7.428,3h-3.3C3.619,3,3,3.229,3,3.943a16.334,16.334,0,0,0,16.2,16.2,1,1,0,0,0,.943-1.124V15.732a.951.951,0,0,0-.943-.943Z'
            fill='currentColor'
            transform='translate(0.429 0.429)'
          />
        </g>
      ),
    },
    m: {
      code: (
        <g clipPath='url(#clip0_302_2)'>
          <path
            d='M16.3575 12.6825C15.4061 12.6821 14.4607 12.5322 13.5558 12.2383C13.4178 12.1916 13.2694 12.1848 13.1276 12.2185C12.9858 12.2523 12.8564 12.3253 12.7542 12.4292L11.5042 13.9925C9.13854 12.8332 7.21802 10.9305 6.03668 8.57583L7.58751 7.25417C7.6895 7.1483 7.76076 7.01667 7.79364 6.87339C7.82653 6.73011 7.8198 6.58058 7.77418 6.44083C7.47646 5.5369 7.32648 4.59086 7.33001 3.63917C7.32721 3.43259 7.24384 3.23527 7.09767 3.08926C6.9515 2.94325 6.7541 2.86009 6.54751 2.8575H3.79751C3.37335 2.8575 2.85751 3.04833 2.85751 3.64333C2.88669 7.21473 4.31838 10.6316 6.84382 13.157C9.36927 15.6825 12.7861 17.1142 16.3575 17.1433C16.4722 17.1377 16.5844 17.1084 16.6872 17.0574C16.79 17.0063 16.8812 16.9346 16.955 16.8466C17.0288 16.7587 17.0836 16.6564 17.116 16.5463C17.1484 16.4362 17.1577 16.3206 17.1433 16.2067V13.4675C17.1416 13.2596 17.0583 13.0608 16.9113 12.9138C16.7643 12.7668 16.5654 12.6834 16.3575 12.6817V12.6825Z'
            fill='currentColor'
          />
        </g>
      ),
    },
    s: {
      code: (
        <g clipPath='url(#clip0_302_2)'>
          <path
            d='M13.086 10.146C12.3249 10.1457 11.5686 10.0258 10.8447 9.79067C10.7342 9.75331 10.6155 9.74781 10.5021 9.77481C10.3886 9.80181 10.2851 9.86022 10.2033 9.94333L9.20334 11.194C7.31083 10.2666 5.77442 8.74444 4.82934 6.86067L6.07001 5.80333C6.1516 5.71864 6.20861 5.61333 6.23492 5.49871C6.26122 5.38409 6.25584 5.26446 6.21934 5.15267C5.98117 4.42952 5.86118 3.67269 5.86401 2.91133C5.86176 2.74607 5.79507 2.58821 5.67814 2.47141C5.5612 2.3546 5.40328 2.28807 5.23801 2.286H3.03801C2.69868 2.286 2.28601 2.43867 2.28601 2.91467C2.30936 5.77178 3.4547 8.50526 5.47506 10.5256C7.49541 12.546 10.2289 13.6913 13.086 13.7147C13.1777 13.7102 13.2675 13.6867 13.3498 13.6459C13.432 13.605 13.505 13.5476 13.564 13.4773C13.623 13.4069 13.6669 13.3251 13.6928 13.237C13.7187 13.149 13.7262 13.0564 13.7147 12.9653V10.774C13.7133 10.6077 13.6466 10.4486 13.529 10.331C13.4114 10.2134 13.2523 10.1467 13.086 10.1453V10.146Z'
            fill='currentColor'
          />
        </g>
      ),
    },
  },
};
